import { useState } from "react";
import "./../../globals.scss";
import styles from "./Avatar.module.scss";
import { avatarColor, getInitials } from "./initials";

export interface AvatarProps {
  /** Full display name; used for the accessible label and, if no first/last, for initials. */
  name: string;
  firstName?: string;
  lastName?: string;
  /** Resolved image URL. Falls back to initials while loading, on error, or when absent. */
  imgUrl?: string;
  /** Width in px; a portrait is 4/3 as tall, the same 3:4 frame profile photos are uploaded in. */
  size?: number;
  shape?: "circle" | "portrait";
  className?: string;
}

export function Avatar({
  name,
  firstName,
  lastName,
  imgUrl,
  size = 38,
  shape = "circle",
  className,
}: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const initials = getInitials(firstName, lastName, name);
  const dimension = {
    width: size,
    height: shape === "portrait" ? Math.round((size * 4) / 3) : size,
    fontSize: Math.round(size * 0.36),
  };
  const shapeClass = shape === "portrait" ? styles.portrait : "";

  if (imgUrl && !failed) {
    return (
      <img
        src={imgUrl}
        alt={name}
        className={`${styles.avatar} ${shapeClass} ${className ?? ""}`}
        style={dimension}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span
      role="img"
      aria-label={name}
      className={`${styles.avatar} ${styles.initials} ${shapeClass} ${className ?? ""}`}
      style={{ ...dimension, background: avatarColor(initials || name) }}
    >
      {initials}
    </span>
  );
}
